import { colorsPalettes } from "@similarweb/styles";
import { ProgressBar } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { ICategoryComparison } from "app/pages/industry-analysis/categories-context";
import { useCategoriesComparison } from "app/pages/industry-analysis/categories-context";

import type { DeviceDistributionWebSourceData } from "../types";

import { DeviceDistributionComparisonLegendBulletItems } from "./DeviceDistributionComparisonLegendBullets";
import { calculateShareValues } from "./utils";

const PRIMARY_COLOR_SET = [colorsPalettes.midnight["300"], colorsPalettes.midnight["100"]];
const COMPARED_COLOR_SET = [colorsPalettes.orange["400"], colorsPalettes.orange["200"]];

const labelRenderer = (value: number) => {
    return <Flex margin="0 0 0 2px">{(value * 100).toFixed(1)}%</Flex>;
};

type DeviceDistributionComparisonShareBarProps = {
    category: ICategoryComparison;
    data: DeviceDistributionWebSourceData;
};

export const DeviceDistributionComparisonShareBar = ({ category, data }: DeviceDistributionComparisonShareBarProps) => {
    const { primaryCategory } = useCategoriesComparison();
    const isPrimary = category.category.id === primaryCategory.id;
    const colorSet = isPrimary ? PRIMARY_COLOR_SET : COMPARED_COLOR_SET;
    const values = calculateShareValues(data);

    return (
        <Flex
            gap="8px"
            flexDirection="column"
            data-automation="device-distribution-comparison-share-bar"
        >
            <Flex
                justifyContent="space-between"
                alignItems="center"
            >
                <Text fontVariant="body2">{category.category.text}</Text>
                <DeviceDistributionComparisonLegendBulletItems
                    values={values}
                    colorSet={colorSet}
                />
            </Flex>
            <ProgressBar
                showLabels
                height="16px"
                values={values}
                colorSet={colorSet}
                labelRenderer={labelRenderer}
            />
        </Flex>
    );
};
